import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import frCA from "./locales/fr-CA.json";
import { getStoredLocale, normalizeLocaleForI18n } from "@/utils/localeCookie";

const resources = {
    en: { translation: en },
    "fr-CA": { translation: frCA },
};

/**
 * Determine the initial locale based on:
 * 1. NEXT_LOCALE cookie (highest priority)
 * 2. Variant-specific default (CADA -> fr-CA, others -> en)
 */
function getInitialLocale(): string {
    const isCada = process.env.NEXT_PUBLIC_VARIANT === "cada";

    // Check for stored preference in cookie
    const storedLocale = getStoredLocale();
    if (storedLocale) {
        // Normalize to i18next format (fr -> fr-CA)
        return normalizeLocaleForI18n(storedLocale);
    }

    // Fall back to variant-specific default
    return isCada ? "fr-CA" : "en";
}

i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLocale(),
    fallbackLng: "en",
    keySeparator: ".",

    interpolation: {
        escapeValue: false,
        format: (value, format, lng) => {
            if (value instanceof Date) {
                if (format === "shortMonth") {
                    return new Intl.DateTimeFormat(lng, { month: "short" }).format(value);
                }
                // Add other date formats as needed
                return new Intl.DateTimeFormat(lng).format(value);
            }
            return value;
        },
    },
});

export const i1 = i18n;
